import React from 'react';
import { FadeIn } from './ui/FadeIn';
export const Guarantee = () => {
  return <section className="py-20 md:py-24 bg-dark-card border-y border-white/5" data-id="element-75">
      <div className="container mx-auto px-4" data-id="element-76">
        <FadeIn data-id="element-77">
          <div className="relative max-w-[600px] mx-auto bg-[#111111] rounded-2xl p-8 md:p-10 text-center overflow-hidden" style={{
          borderTop: '3px solid transparent',
          backgroundImage: 'linear-gradient(#111111, #111111), linear-gradient(90deg, #ADFF2F, #6ECC1F, #ADFF2F)',
          backgroundOrigin: 'border-box',
          backgroundClip: 'padding-box, border-box'
        }} data-id="element-78">
            {/* Shield circle */}
            <div className="w-20 h-20 rounded-full bg-[#ADFF2F] flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(173,255,47,0.4)]" data-id="element-79">
              <span className="text-4xl" data-id="element-80">🛡️</span>
            </div>

            {/* Badge */}
            <div className="inline-block border border-[#ADFF2F] text-[#ADFF2F] text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5 font-sans" data-id="element-81">
              Garantía
            </div>

            {/* Heading */}
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-5 leading-tight" data-id="element-82">
              Garantía de 7 días
            </h3>

            {/* Body */}
            <p className="text-gray-300 text-base md:text-lg leading-relaxed font-sans max-w-md mx-auto m-0" data-id="element-83">
              🛡️ Si revisas el contenido y sientes que no es lo que necesitas,{' '}
              <span className="text-white font-semibold" data-id="element-84">
                te devolvemos el dinero sin preguntas.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};